import React from "react";
import { mergeRefs } from "@sproutsocial/seeds-react-utilities";
import { StyledCard } from "./styles";
import type { TypeCardProps } from "./CardTypes";
import { useCardBehavior } from "./useCardBehavior";
import { SelectedIcon } from "./subComponents";

/**
 * Styled-components implementation of Card. Used by CardHybrid whenever a
 * consumer passes a styled-system prop, a BORDER-mixin prop, or a styled()
 * extension. Behaviour is shared with CardTailwind via useCardBehavior.
 */
const CardStyled = React.forwardRef<HTMLDivElement, TypeCardProps>(
  (
    {
      children,
      disabled = false,
      elevation = "low",
      href,
      onClick,
      role = "presentation",
      selected,
      ...rest
    }: TypeCardProps,
    ref
  ) => {
    const {
      containerRef,
      cardContext,
      hasSubComponent,
      isRoleLink,
      SubComponentContext,
      containerProps,
    } = useCardBehavior({ disabled, href, onClick, role, selected });

    return (
      <StyledCard
        {...containerProps}
        $elevation={elevation}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore legacy ref type mismatch between the RefObject and callback ref
        ref={mergeRefs(containerRef, ref)}
        $selected={selected}
        $disabled={disabled}
        $compositionalComponents={hasSubComponent}
        $isRoleLink={isRoleLink}
        {...rest}
      >
        <SelectedIcon $selected={selected} />
        <SubComponentContext.Provider value={cardContext}>
          {children}
        </SubComponentContext.Provider>
      </StyledCard>
    );
  }
);

CardStyled.displayName = "Card";
export default CardStyled;
